import React from "react";
import "./Frame42.css";

function Frame42(props) {
  const { className } = props;

  return (
    <div className={`frame-4-52-1 ${className || ""}`}>
      <div className="yes-37 subtitel">Yes</div>
    </div>
  );
}

export default Frame42;
